import { NgClass, NgStyle } from "@angular/common";
import { Component, ElementRef, Inject } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, Platform } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { SocialService } from "../../services/social.service";
@Component({
  selector: "app-owned-photo-popup",
  templateUrl: "./owned-photo-popup.component.html",
  styleUrls: ["./owned-photo-popup.component.scss"],
  standalone: true,
  imports: [
    LottieComponent,
    IonicModule,
    NgStyle,
    NgClass,
    TranslatePipe,
  ],
})
export class OwnedPhotoPopupComponent {
  public selectedImageData: Data;
  public subCategory: string;
  public islikedImages: Data;
  public likedImg: boolean;
  public removePopup: boolean;
  public confirmRemoveImg: boolean;
  public mineImageLength: number;
  public mineImageLimit: number;
  public bottomBarToggle: boolean;
  public UnsplashByCollection: Data;
  public selectedLanguage: string;
  public spanish: boolean;
  public addBtnHide: boolean;
  public liked: boolean;
  public image: string;
  public category: string;
  public mineImageData: Data;
  public showAnimation: boolean;
  public showaddAnimation: boolean;
  public userId: string;

  constructor(
    public dialogRef: MatDialogRef<OwnedPhotoPopupComponent>,
    private analytics: AngularFireAnalytics,
    @Inject(MAT_DIALOG_DATA)
    public data: Data,
    private socialService: SocialService,
    private platform: Platform,
    public translate: TranslateService,
    private authService: AuthService,
    private elementRef: ElementRef
  ) {
    // This variables has been used to contain the boolean value for remove popup class
    this.removePopup = false;
    this.bottomBarToggle = true;
    if (this.platform.is("android")) {
      this.removePopup = true;
    }
    try {
      this.selectedImageData = data;
      this.mineImageLength = this.selectedImageData.mineImageData?.images?.length;
      this.mineImageLimit = this.selectedImageData.mineImageData?.limit;
      this.category = data?.category?.toLowerCase();
      this.subCategory = data?.subcategory?.toLowerCase();
      // This method has been used to get the Liked images
      this.socialService.likedLifestyleImages(this.subCategory);
      this.socialService.getMineSectionImages(this.category, this.subCategory).subscribe((res: Data) => {
        this.mineImageData = res;
      });
    } catch (err) {
      // Handle error
      throw new Error(`Image data not fount:${err}`);
    }
    // This method has been used to create logEvent
    // This method has been used to get the Liked images
    this.socialService
      .getLikedImages(this.subCategory)
      .pipe(
        catchError((err) => {
          // Handle error
          return throwError(err);
        })
      )
      .subscribe((res: Data) => {
        try {
          // This variables contain all images data and matched images
          const allImages = res?.images;
          const imagesMatch = allImages?.some((item) => item === this.selectedImageData?.imageURL);
          // This condition check if image URL is matched
          if (imagesMatch) {
            this.likedImg = true;
          }
          // This condition check blank space image URL
          if (this.selectedImageData?.imageURL.includes(' ')) {
            this.image = this.selectedImageData?.imageURL.replace(/\s/g, '%20');
          }
          else {
            this.image = this.selectedImageData?.imageURL;
          }
        } catch (err) {
          // Handle error
          throw new Error(`Image data not fount:${err}`);
        }
      });
    // This method has been used to get the user language
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
        if (l == "es") {
          this.spanish = true;
        }
      },
      (err) => {
        return err;
      }
    );
    // This condition check if image length is more than limit
    if (this.mineImageLength >= this.mineImageLimit) {
      this.addBtnHide = false;
    } else {
      this.addBtnHide = true;
    }

  }

  async ngOnInit() {
    await this.authService.getUid("OwnedPhotoPopupComponent").then((uid) => {
      this.userId = uid;
    })
    this.analytics.logEvent("syndicate_member_modal", { userId: this.userId });

  }
  // json icons path
  public options: AnimationOptions = {
    path: "./../../../../assets/coinani.json",
    loop: false,
  };
  public reaction_options: AnimationOptions = {
    path: "./../../../../assets/heartani.json",
    loop: false,
  };

  // This method has been used to close the popup
  close() {
    this.dialogRef.close();
    this.bottomBarToggle = true;
  }
  // This method has been used to toggle the liked images or unlike images
  public isChangeLimitAccessToggle(event: boolean, selectedImageData: Data) {
    if (event) {
      this.liked = true;
      // This method has been used to add liked images
      this.socialService.addLikedLifestyleImages(selectedImageData);
      this.likeAnimation();
    }
    if (!event) {
      this.liked = false;
      // This method has been used to remove liked images
      this.socialService.removeLikedLifestyleImages(selectedImageData);
    }
  }

  likeAnimation() {
    this.showAnimation = true;
    setTimeout(() => {
      this.showAnimation = false;
    }, 3000);
  }
  addAnimation() {
    this.showaddAnimation = true;
    setTimeout(() => {
      this.showaddAnimation = false;
    }, 3000);
  }
  // This method has been used to add image in user album
  public addAlbumImage(selectedImageData: Data) {
    this.addAnimation();
    // This condition check if images liked or not
    if (this.likedImg === true || this.liked === true) {
      this.socialService.addSelectedImage(selectedImageData, true);
    } else {
      this.socialService.addSelectedImage(selectedImageData, false);
    }
    // This method has been used to close the popup
    setTimeout(() => {
      this.dialogRef.close();
    }, 2000); // 2000 milliseconds = 2 seconds
    this.bottomBarToggle = true;
    const isMatched = this.mineImageData?.images.some((item) => item.image_url === selectedImageData?.imageURL);
    // This condition check if image length is more than limit
    if (this.mineImageLength < this.mineImageLimit && !isMatched) {
      // This method has been used to show toast message
      this.socialService.getConstantsMsg("1109").then((translatedMsg) => {
        const message = translatedMsg?.message?.line_1.split("image");
        const text = selectedImageData?.searchTerms;
        const dynamicMessage = message?.[0] + text + message?.[1];
        if (translatedMsg?.message?.line_1) {
          translatedMsg.message.line_1 = dynamicMessage;
        }
        const defaultMsg = {
          message: {
            line_1: "Success! You have added a new image to your album",
            line_2: "",
          },
          style: {
            icon: "tick circle success.png",
            type: "Success",
          },
        };
        this.socialService.showToastMessage(translatedMsg, defaultMsg);
      })
        .catch((error) => {
          return error;
        });
    }
  }
  // This method has been used to Add toggle
  public async AddToggle() {
    this.confirmRemoveImg = true;
    this.bottomBarToggle = false;
  }

  // This method has been used to get the width
  public getWidth() {
    const parent = this.elementRef.nativeElement.querySelector('.myElement');
    if (parent && parent.length) {
      return parent[0].clientWidth + 2;
    }
    return 'inherit';
  }
}
